import api from './api';

export const getQueueOptions = () => api.get('/queue/options');
export const getQueues = () => api.get('/queue');
export const getQueue = (id) => api.get(`/queue/${id}`);
export const createQueue = (data) => api.post('/queue', data);
export const updateQueue = (id, data) => api.put(`/queue/${id}`, data);
export const deleteQueue = (id) => api.delete(`/queue/${id}`);

export const getQueueIntegrations = (params) => api.get('/queueIntegration/', { params });
export const getQueueIntegration = (id) => api.get(`/queueIntegration/${id}`);
export const createQueueIntegration = (data) => api.post('/queueIntegration', data);
export const updateQueueIntegration = (id, data) => api.put(`/queueIntegration/${id}`, data);
export const testQueueIntegration = (data) => api.post('/queueIntegration/testSession', data);
export const deleteQueueIntegration = (id) => api.delete(`/queueIntegration/${id}`);
